var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"text-h3 font-weight-bold"},[_vm._t("title")],2),_c('v-card-text',[_vm._t("text"),_vm._t("button")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }